import React from "react";

export const VisibilityIconOff = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9944 11.3329C14.1539 10.9066 14.2348 10.4548 14.2332 9.99959C14.2332 8.98882 13.8317 8.01945 13.117 7.30472C12.4023 6.59 11.4329 6.18848 10.4221 6.18848C9.97252 6.189 9.52661 6.2699 9.10547 6.42737L9.99991 7.34959C10.1359 7.32783 10.2733 7.31669 10.411 7.31625C11.1257 7.31476 11.812 7.59611 12.3199 8.09886C12.8279 8.60161 13.1163 9.28492 13.1221 9.99959C13.1217 10.1373 13.1105 10.2747 13.0888 10.4107L13.9944 11.3329Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M19.0516 9.73915C17.1793 6.27804 13.896 4.18359 10.2627 4.18359C9.27342 4.18592 8.29082 4.34531 7.35156 4.65582L8.24601 5.55582C8.90481 5.38555 9.58223 5.29785 10.2627 5.2947C13.3905 5.2947 16.2349 7.03915 17.9293 9.97804C17.3078 11.0684 16.4838 12.03 15.5016 12.8114L16.2905 13.6003C17.4272 12.6832 18.3712 11.5504 19.0682 10.2669L19.2127 10.0003L19.0516 9.73915Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M2.70365 3.21157L5.18142 5.68934C3.61527 6.69774 2.33526 8.09255 1.46476 9.73935L1.32031 10.0005L1.46476 10.2671C3.33698 13.7282 6.62031 15.8227 10.2536 15.8227C11.6718 15.8224 13.0715 15.5014 14.3481 14.8838L17.1259 17.6616L18.0981 16.8282L3.65365 2.38379L2.70365 3.21157ZM8.12031 8.62823L11.8148 12.3227C11.3973 12.5811 10.9168 12.7195 10.4259 12.7227C10.0692 12.7227 9.71598 12.6522 9.38663 12.5151C9.05729 12.3781 8.75829 12.1774 8.50683 11.9244C8.25538 11.6714 8.05644 11.3711 7.92146 11.0409C7.78647 10.7108 7.71812 10.3572 7.72031 10.0005C7.72657 9.51521 7.86485 9.04084 8.12031 8.62823ZM7.31476 7.82268C6.795 8.55568 6.55138 9.44895 6.62704 10.3443C6.7027 11.2397 7.09276 12.0795 7.72815 12.7148C8.36354 13.3502 9.20327 13.7403 10.0987 13.8159C10.994 13.8916 11.8873 13.648 12.6203 13.1282L13.5092 14.0171C12.4802 14.457 11.3727 14.6838 10.2536 14.6838C7.12587 14.6838 4.28142 12.9393 2.58698 10.0005C3.40015 8.56058 4.57127 7.35501 5.98698 6.50046L7.31476 7.82268Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
